import useMonthlyRecurringRevenue from "./useMonthlyRecurringRevenue";
import useUserAnnualTarget from "./useUserAnnualTarget";
import useSignupCountGraph from "./useSignupCountGraph";

const useCompanySales = () => {
    const { isMRRLoading, monthlyRecurringRevenueData, totalRevenue, currencyFormatter } = useMonthlyRecurringRevenue()
    const { totalAnnualTarget, annualTargetLoading } = useUserAnnualTarget();
    const { totalSignups, isLoading, chartData, interval } = useSignupCountGraph();

    return {
        isMRRLoading,
        monthlyRecurringRevenueData,
        totalRevenue,
        currencyFormatter,
        totalAnnualTarget,
        annualTargetLoading,
        totalSignups,
        isLoading,
        interval,
        chartData,
    }

}

export default useCompanySales
